import { useContext } from 'react';
import {
  NotificationModeStateContext,
  NotificationModeDispatchContext,
} from './model';

export const useNotificationModeState = () => {
  const context = useContext(NotificationModeStateContext);
  if (context === undefined) {
    throw new Error(
      'useNotificationModeState должен использоваться с NotificationModeProvider'
    );
  }
  return context;
};

export const useNotificationModeDispatch = () => {
  const context = useContext(NotificationModeDispatchContext);
  if (context === undefined) {
    throw new Error(
      'NotificationModeDispatchContext должен использоваться с NotificationModeProvider'
    );
  }
  return context;
};
